export default __webpack_public_path__ + "static/media/empty.d949a798.svg";